import $ from "jquery";
export default function magazinGallery() {

        $('.avu-magazin-image-single').click(function(){
            let src = $(this).attr('src');
            let alt = $(this).attr('alt');
            $('#img01').attr('src', src);

            // save image from current accordion
            currentImages = $(this).closest('.avu-services-post').find('.avu-magazin-image-single');
            currentImageIndex = currentImages.index(this);

            $('#imageMagazinPreviewModal').show();
        });

        // close Modal
        $('.close').click(function(){
            $('#imageMagazinPreviewModal').hide();
        });

        // image navigation
        $('.next').click(function(){
            navigateImage(1);
        });
        $('.prev').click(function(){
            navigateImage(-1);
        });

        let currentImages;
        let currentImageIndex;

        function navigateImage(direction){
            currentImageIndex += direction;

            if(currentImageIndex >= currentImages.length) currentImageIndex = 0;
            if(currentImageIndex < 0) currentImageIndex = currentImages.length - 1;

            let newImageSrc = $(currentImages[currentImageIndex]).attr('src');
            $('#img01').attr('src', newImageSrc);
        }

}







